document.addEventListener('DOMContentLoaded', function() {
  var modal = document.getElementById("bundle-video-popup");
  var closeBtn = document.getElementById("bundle-video-close");
  var videoIframe = document.getElementById("bundle-video-iframe");
  var triggerButtons = document.querySelectorAll(".bundle-video-trigger");
  
  triggerButtons.forEach(function(btn) {
    btn.onclick = function() {
      var vimeoId = this.getAttribute('data-vimeo-id');
      var itemTitle = this.getAttribute('data-item-title');
            
      if (vimeoId && modal && videoIframe) {
        var videoId = vimeoId;
        if (vimeoId.includes('vimeo.com') || vimeoId.includes('player.vimeo.com')) {
          if (vimeoId.includes('/video/')) {
            videoId = vimeoId.split('/video/')[1].split('/')[0].split('?')[0];
          } else if (vimeoId.includes('/playback/')) {
            videoId = vimeoId.split('/playback/')[1].split('/')[0].split('?')[0];
          }
        }
                
        var vimeoUrl = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1&muted=0';
        videoIframe.setAttribute('src', vimeoUrl);
        
        modal.style.display = "flex";
        document.body.style.overflow = "hidden";
      }
    }
  });
  
  function closePopup() {
    if (modal && videoIframe) {
      modal.style.display = "none";
      document.body.style.overflow = "";
      videoIframe.setAttribute('src', '');
    }
  }
  
  if (closeBtn) {
    closeBtn.onclick = function() {
      closePopup();
    }
  }
  
  if (modal) {
    modal.onclick = function(event) {
      if (event.target == modal) {
        closePopup();
      }
    }
  }
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal && modal.style.display === 'flex') {
      closePopup();
    }
  });
});

